import { motion, useScroll, useTransform } from "framer-motion";
import React, { useRef } from "react";

const CarruselVertical = ({
  children,
  outputA,
  outputB,
  title,
  info,
  link,
}) => {
  const targetRef = useRef(null);
  const { scrollYProgress } = useScroll({
    target: targetRef,
    offset: ["start start", "end end"],
  });
  const y = useTransform(scrollYProgress, [0, 1], [outputA, outputB]);
  return (
    <section
      ref={targetRef}
      className="relative h-[300vh] bg-neutral-900 max-w-5xl mx-auto"
    >
      <div className="sticky top-0 flex h-screen justify-center items-center overflow-hidden gap-10">
        <div className="w-1/2 relative">
          <motion.div style={{ y }} className="flex flex-col gap-4 p-2 items-end ">
            {children}
          </motion.div>
        </div>
        <div className="w-1/2 flex flex-col gap-5">
          <h2 className="text-5xl xl:text-6xl text-primario font-bold font-Bebas hyphens-none">
            {title}
          </h2>
          {info ? <p className="text-xl xl:text-2xl">{info}</p> : ""}
          {link ? (
            <a
              href={link}
              rel="noreferrer"
              target="_blank"
              className="bg-primario font-semibold text-secundario py-2 rounded-full rounded-tl-none w-fit"
            >
              <span className="px-4 ">Conoce nuestro programa</span>
            </a>
          ) : (
            ""
          )}
        </div>
      </div>
    </section>
  );
};

export default CarruselVertical;
